'use client';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { getTheme } from './themeConfig';

/**
 * @param {*} prop - React props
 * @param {import('react').ReactElement} prop.children - React child components
 * @returns {import('@mui/material').Theme} - Selected Theme
 */
export const ThemeProvider = ({ children, palette }) => {
  const theme = getTheme(palette);
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
